import { render, staticRenderFns } from "./BusinessTripReportPDF.vue?vue&type=template&id=2b163af2&scoped=true&"
import script from "./BusinessTripReportPDF.vue?vue&type=script&lang=js&"
export * from "./BusinessTripReportPDF.vue?vue&type=script&lang=js&"
import style0 from "./BusinessTripReportPDF.vue?vue&type=style&index=0&id=2b163af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b163af2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VProgressCircular,VSnackbar,VSpacer,VToolbar,VToolbarTitle})
